import { render, staticRenderFns } from "./EditorX.vue?vue&type=template&id=13a2a1a8&scoped=true"
import script from "./EditorX.vue?vue&type=script&lang=js"
export * from "./EditorX.vue?vue&type=script&lang=js"
import style0 from "./EditorX.vue?vue&type=style&index=0&id=13a2a1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2a1a8",
  null
  
)

export default component.exports